import React from "react";
import bannerAnimation from "images/banners/LP-03022025.jpg";
import "./send-money.scss";

/* banner-bg ltr:banner-bg-fr rtl:banner-bg-ar bg-no-repeat bg-cover  lg:rtl:banner-bg-ar lg:ltr:banner-bg-fr */
const SendMoney = () => {
  return (
    <div className="relative flex flex-col">
      {/* <video
        preload="auto"
        className="w-full"
        controls={false}
        autoPlay
        playsInline
        loop
        muted
      >
        <source src={bannerAnimation} type="video/mp4" />
      </video> */}
      <img src={bannerAnimation} alt="" />
    </div>
  );
};

export default SendMoney;
